<input #checkboxElement
       type="checkbox"
       [id]="id"
       (change)="updateValue(checkboxElement.checked)">

<label [for]="id">
  <ng-content></ng-content>
</label>
